import { grey } from "@mui/material/colors";

import { pageStyles } from "components/Styled/Page/styles";
import { tableStyles } from "components/Styled/Table/sharedStyles";
import { TemplateContentType } from "features/Influencer/ContactList/schema";

const styles = {
  ...pageStyles,
  ...tableStyles,
  button: {
    fontSize: 16,
    color: "black",
  },
  contentTypeChip: (contentType: TemplateContentType) => ({
    px: 1,
    backgroundColor:
      contentType === TemplateContentType.OUTREACH ? "purple.light" : "#F9FAE1",
    color: "black",
    border: `1px solid`,
    borderColor: grey[700],
    fontSize: 12,
  }),
  root: {
    pb: "60px",
  },
  banner: {
    backgroundColor: "secondary.light",
    px: 2,
    py: 1,
    borderRadius: 4,
  },
};

export default styles;
